"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bulkRemindContractsApiResponseSchema = void 0;
const zod_1 = require("zod");
exports.bulkRemindContractsApiResponseSchema = zod_1.z.object({
    count: zod_1.z.number(),
});
